export default "__VITE_ASSET__d5339a69__"